module.exports = __webpack_public_path__ + "img/logo-topdoctors-vectores.3ceb547a.svg";